import { useEffect, useState } from "react";
import { fetchTopSuburbsByIndicator } from "../api/infoApi";

export default function useTopSuburbsByIndicator(
  city,
  indicator,
  { order = "desc", limit = 10, secondary } = {}
) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!city || !indicator) {
      setData([]);
      setLoading(false);
      setError(null);
      return;
    }

    let aborted = false;
    setLoading(true);
    setError(null);

    fetchTopSuburbsByIndicator({ city, indicator, secondary, order, limit })
      .then(rows => { if (!aborted) setData(rows ?? []); })
      .catch(err => { if (!aborted) setError(err); })
      .finally(() => { if (!aborted) setLoading(false); });

    return () => { aborted = true; };
  }, [city, indicator, secondary, order, limit]);

  return { data, loading, error };
}
